export type Half = '상반기' | '하반기';

export function halfYearMonths(year: number, half: Half): string[] {
  const start = half === '상반기' ? 1 : 7;
  const months: string[] = [];
  for (let m = start; m < start + 6; m++) {
    months.push(`${year}-${String(m).padStart(2, '0')}`);
  }
  return months;
}

export function toMonth(dateVal: string | number): string {
  if (typeof dateVal === 'number' && Number.isFinite(dateVal)) {
    const d = new Date(Date.UTC(1899, 11, 30) + dateVal * 86400000);
    return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}`;
  }
  const s = String(dateVal).trim();
  const m = s.match(/(\d{4})[.\-/](\d{1,2})/);
  if (!m) return '';
  return `${m[1]}-${m[2].padStart(2, '0')}`;
}
